import Axios from 'axios'

const instance: any = Axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:1337',
})

export default instance;